export default __webpack_public_path__ + "static/media/photo--lg--group-1.5d1b1981.jpg";